import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { GL_ASSIGNMENT_API } from "./apiRoutes";

interface UseGetGLDistributionProps {
  communityId: string;
  year: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getGLDistributionByCommunityYear = async (communityId: string, year: string) =>
  await axiosAuth.get(`${GL_ASSIGNMENT_API(communityId)}/year/${year}`);

const useGetGLDistributionByCommunityYear = ({
  queryParams,
  communityId,
  year
}: UseGetGLDistributionProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["gl-distribution-community-year", communityId, year],
    queryFn: () => getGLDistributionByCommunityYear(communityId, year),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: !!year && !!communityId && (queryParams?.enabled ?? true),
  });
};

export default useGetGLDistributionByCommunityYear;
